import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jira_timeline_rollups_technical_gate');
	},
};
